














import { Component, Vue } from "vue-property-decorator";

import { pathToLanguageID, repositoriesToDays } from "../domain";
import { repositoriesQuery } from "../drivers/apollo";
import Day from "./Day.vue";
import Query from "./Query.vue";

@Component({ components: { Day, Query } })
export default class extends Vue {
  private query = repositoriesQuery;
  private repositoriesToDays = repositoriesToDays;

  private get languageID(): string {
    return pathToLanguageID(this.$route.path);
  }
}
